module.exports = __webpack_public_path__ + "static/media/feature-slideg1.9e70ba47.jpg";